import React, { useEffect, useState } from 'react'
import { IVerifyAnswer, signUpVerify } from '../../api/account'
import { pcDevelopers } from '../../api/utils'
import { Button, Result, Spin, Typography } from 'antd'
import { Link } from 'react-router-dom'
import { useLocation } from 'react-router'

interface IVerifyResultProps {
	answer: IVerifyAnswer
}

interface AntAnswer {
	status: 'success' | 'error'
	title: string
	subTitle: string
	extra: React.ReactElement[]
}

const answers: Record<number, AntAnswer> = {
	500: {
		status: 'error',
		title: 'Ошибка сервера',
		subTitle: 'Похоже, что сервер недоступен.',
		extra: [
			<a
				key="pc-developers-link"
				href={pcDevelopers}
				style={{ textDecoration: 'none' }}
				target="_blank"
				rel="noopener noreferrer"
			>
				<Button type="primary">Сообщить об ошибке</Button>
			</a>,
			<Link key="main-link" to="/" style={{ textDecoration: 'none' }}>
				<Button>На главную</Button>
			</Link>
		]
	},
	403: {
		status: 'error',
		title: 'Отказано в доступе',
		subTitle: 'Данная ссылка недействительна.',
		extra: [
			<a
				href={pcDevelopers}
				target="_blank"
				rel="noopener noreferrer"
			    key="report-link"
			>
				<Button type="primary">Сообщить об ошибке</Button>
			</a>,
			<Link key="main-link" to="/">
				<Button>На главную</Button>
			</Link>
		]
	},
	200: {
		status: 'success',
		title: 'Успешная операция',
		subTitle: 'Аккаунт успешно создан!',
		extra: [
			<Link
				key="download-link"
				to="/download"
				target="_blank" rel="noopener noreferrer"
				style={{ textDecoration: 'none' }}
			>
				<Button type="primary">Скачать лаунчер</Button>
			</Link>,
			<Link key="main-link" to="/" style={{ textDecoration: 'none' }}>
				<Button>На главную</Button>
			</Link>
		]
	}
}

const VerifyResult = (props: IVerifyResultProps) => (
	<Result
		status={answers[props.answer.code]?.status}
		title={answers[props.answer.code]?.title}
		subTitle={answers[props.answer.code]?.subTitle}
		extra={answers[props.answer.code]?.extra}
	/>
)

// eslint-disable-next-line react/no-multi-comp
export const SignUpVerify = (): React.ReactElement => {
	const [isLoading, setIsLoading] = useState(true)
	const [serverAnswer, setServerAnswer] = useState<IVerifyAnswer>({ code: 500 })
	const link = new URLSearchParams(useLocation().search).get('link')

	async function verify() {
		try {
			const res = await signUpVerify(link ? link : '')
			setServerAnswer(res)
		} catch {
			setServerAnswer({ code: 500 })
		}

		setIsLoading(false)
	}

	useEffect(() => {
		void verify()
	}, [link])

	return (
		<div>
			{isLoading ?
				<div>
					<Spin/>
					<Typography.Title level={3}>Подождите...</Typography.Title>
				</div> : <></>
			}


			{
				isLoading ? <></> : <VerifyResult answer={serverAnswer}/>
			}
		</div>
	)
}

export const routePathSignUpVerify = '/verify/signUp'
